<div class="alert-card">
  <div class="title">
    <fa-icon [icon]="['fas', 'bell']"></fa-icon>
    <span [innerHTML]="alert?.title | highlight: searchQuery"></span>
    <span>{{
      "(" +
        alertService.formatTimestampToNow(
          alert.last_triggered_timestamp * 1000
        ) +
        ")"
    }}</span>
  </div>

  <div class="info">
    <ng-container *ngFor="let item of generalAlertInfo">
      <div class="info-row">
        <div class="text">
          <div class="icon"><fa-icon [icon]="item.icon"></fa-icon></div>
          {{ item.label | translate }}
        </div>
        <a
          *ngIf="item.url"
          [href]="item.url"
          class="value"
          [innerHTML]="
            item.highlight ? (item.value | highlight: searchQuery) : item.value
          "
        ></a>
        <span *ngIf="!item.url" class="value">{{ item.value }}</span>
      </div>
    </ng-container>

    <ng-container *ngIf="alert?.trigger_type?.id == 1">
      <ng-container *ngFor="let item of postTriggerAlertInfo">
        <div class="info-row">
          <div class="text">
            <div class="icon"><fa-icon [icon]="item.icon"></fa-icon></div>
            {{ item.label | translate }}
          </div>
          <div class="value">{{ item.value }}</div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="alert?.trigger_type?.id == 2">
      <ng-container *ngFor="let item of volumeTriggerAlertInfo">
        <div class="info-row">
          <div class="text">
            <div class="icon"><fa-icon [icon]="item.icon"></fa-icon></div>
            {{ item.label | translate }}
          </div>
          <div class="value">{{ item.value }}</div>
        </div>
      </ng-container>
    </ng-container>

    <div class="info-row" *ngIf="alert?.active_filters?.length > 0">
      <div class="text">
        <div class="icon"><fa-icon [icon]="['fas', 'filter']"></fa-icon></div>
        {{ "alert-card.title.attached-dimension" | translate }}
      </div>
      <div class="value">{{ alert.active_filters[0]?.title }}</div>
    </div>

    <div class="tools">
      <div
        *ngIf="alert?.mode"
        class="status"
        [ngClass]="{
          running: alert?.mode?.id == 1,
          paused: alert?.mode?.id == 2,
        }"
        (click)="toggleAlertMode(alert.id)"
      >
        <span>{{ alert.mode.title }}</span>
        <fa-icon
          [icon]="alert.mode?.id == 1 ? ['fas', 'pause'] : ['fas', 'play']"
        ></fa-icon>
      </div>
      <sui-button
        class="edit-btn"
        size="sm"
        variant="primary"
        [leadingIcon]="['fas', 'edit']"
        [iconOnly]="true"
        ariaLabel="Edit"
        (click)="editAlert()"
      ></sui-button>

      <sui-button
        class="delete-btn"
        size="sm"
        variant="danger"
        [leadingIcon]="['fas', 'trash']"
        [iconOnly]="true"
        ariaLabel="Delete"
        (click)="deleteAlert()"
      ></sui-button>
    </div>
  </div>
</div>
